import {useState} from "react";
import * as ClientApi from "~/lib/ClientApi";

function usePrefillClientForm(formData, setFormData, formId)
{
    const [previousPrefill, setPreviousPrefill] = useState({});

    /**
     * Go through the key/value pairs in data
     * and delete anything where the key/value exactly matches removeIfMatchingData
     */
    function removeDataMatching(data, removeIfMatchingData)
    {
        let newData = {...data};
        Object.keys(removeIfMatchingData).forEach((key) => {
            if (data[key]
                && JSON.stringify(data[key]) === JSON.stringify(removeIfMatchingData[key])
            ) {
                delete newData[key];
            }
        })

        return newData;
    }

    /**
     * Merge prefillData into formData
     * but only if formData is empty or non-existant
     */
    function mergeAnswers(prefillData, formData)
    {
        let newData = {...formData};
        Object.keys(prefillData).forEach((key) => {
            if (!newData[key]) {
                newData[key] = prefillData[key];
            }
        })

        return newData;
    }

    function prefill(prefillData, prefillClient)
    {
        setFormData((old) => {
            let newData = removeDataMatching(old, previousPrefill);
            newData = mergeAnswers(prefillData, newData);

            return {
                ...newData,
                loggedInClient: prefillClient,
            };
        })

        setPreviousPrefill(prefillData)
    }

    function setClient(client)
    {
        if (typeof setFormData !== 'function') {
            return;
        }

        if (!client) {
            prefill({}, null);
            return;
        }

        ClientApi.get(`/account/prefill/${formId}/${client.id}`).then((result) => {
            prefill(result.answers, client);
        })
    }

    return {
        setClient,
    }
}

export default usePrefillClientForm;
